var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(0 0.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 20,
    height: 20,
    transform: "translate(0 -0.09)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(0 -0.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    d: "M1,0H3.264a1,1,0,0,1,1,1V14.578a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(13.615 2.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    d: "M1,0H3.264a1,1,0,0,1,1,1V7.609a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(7.942 9.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    d: "M1,0H3.264a1,1,0,0,1,1,1V7.609a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(2.269 9.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1711.648,2182.32a.375.375,0,0,0-.323-.1l-3.273.527a.374.374,0,0,0-.205.633l.92.919-1.479,1.487-2.327-2.037a.654.654,0,0,0-.888.024l-2.5,2.442.913.937,2.071-2.02,2.334,2.043a.654.654,0,0,0,.895-.031l1.909-1.92.9.9a.374.374,0,0,0,.633-.2l.527-3.273A.374.374,0,0,0,1711.648,2182.32Z",
    transform: "translate(-1699.377 -2178.339)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteReport);
export default __webpack_public_path__ + "static/media/white_report.a6cdec77290ad89e259d18ee6da145da.svg";
export { ForwardRef as ReactComponent };